import { PropsWithChildren } from "react";
import NavMenu from "./NavMenu";
import Header from "./Header";
import { CircularProgress, useTheme } from "@mui/joy";
import React from "react";
import { Util } from "./Helpers/Util";
interface LayoutProps {}
export default function Layout(props: PropsWithChildren<LayoutProps>) {
	const theme = useTheme();
	const [loading, setLoading] = React.useState(true);

	React.useEffect(() => {
		fetch("/User/GetPersonInfo", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({}),
		})
			.then((x) => x.json())
			.then((y) => {
				setLoading(false)
				Util.CurrentRole = y.role;
			});
	}, []);

	return loading ? <CircularProgress /> : (
		<div style={{ display: "flex", height: "100%", overflowY: "hidden" }}>
			<NavMenu />
			<div style={{ flex: 1, overflowY: "auto", height: "100%", display: "flex", flexDirection: "column", padding: theme.spacing(1) }}>
				<Header />
				{props.children}
			</div>
		</div>)
	
}
